/* eslint-disable import/prefer-default-export -- utilitário de carregamento único */
import { ADSENSE_PUBLISHER_CLIENT } from "../config/adsense";

const SCRIPT_ATTR = "data-bilingua-adsense";

let loadPromise: Promise<void> | null = null;

/**
 * Garante um único carregamento do script oficial com o publisher ID correto.
 */
export function ensureAdsenseScript(
  clientId: string = ADSENSE_PUBLISHER_CLIENT
): Promise<void> {
  if (typeof window === "undefined") {
    return Promise.resolve();
  }

  if (loadPromise) {
    return loadPromise;
  }

  loadPromise = new Promise((resolve, reject) => {
    const existing = document.querySelector<HTMLScriptElement>(
      `script[${SCRIPT_ATTR}="${clientId}"]`
    );
    if (existing) {
      if (existing.dataset.loaded === "1") {
        resolve();
        return;
      }
      existing.addEventListener("load", () => resolve(), { once: true });
      existing.addEventListener(
        "error",
        () => reject(new Error("AdSense script")),
        { once: true }
      );
      queueMicrotask(() => {
        if (existing.dataset.loaded === "1") resolve();
      });
      return;
    }

    const script = document.createElement("script");
    script.async = true;
    script.crossOrigin = "anonymous";
    script.setAttribute(SCRIPT_ATTR, clientId);
    script.src = `https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=${encodeURIComponent(
      clientId
    )}`;
    script.onload = () => {
      script.dataset.loaded = "1";
      resolve();
    };
    script.onerror = () => {
      loadPromise = null;
      reject(new Error("Falha ao carregar AdSense"));
    };
    document.head.appendChild(script);
  });

  return loadPromise;
}
